// extracted by mini-css-extract-plugin
export default {"wrap":"SG-z","articleImagesWrap":"TG-z","articleImage":"UG-z","singleImage":"VG-z"};